export default {
  title: "Clone Item",
  content: 'Do you wish to clone this <b class="text-info">Item</b>?',
}
